import React, { useState } from "react";
import { Box, Typography, IconButton } from "@material-ui/core";
import { ArrowLeft, ArrowRight } from "@material-ui/icons";
import format from "date-fns/format";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import {
  decrementMonth,
  displayToYearMonth,
  incrementYM,
} from "../../util/DateUtil";

interface MonthNavigatorProps {
  value: string;
  onChange: (value: string) => void;
}

const MonthNavigator = (props: MonthNavigatorProps) => {
    
  const { value, onChange } = props;

  const handlePreviousMonth = () => {
    const ymd = decrementMonth(value);
    onChange(ymd);
  };

  const handleNextMonth = () => {
    const ymd = incrementYM(value);
    onChange(ymd);
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <IconButton onClick={handlePreviousMonth}>
        <ArrowLeft />
      </IconButton>
      <Typography variant="h6">{displayToYearMonth(value)}</Typography>
      <IconButton onClick={handleNextMonth}>
        <ArrowRight />
      </IconButton>
    </Box>
  );
};

export default MonthNavigator;
